/**
 * gfxId → NPC 한글 이름 표 — **자동 생성됨. 직접 고치지 말 것.**
 *
 * regenerate: python3 scripts/gen_npc_gfx_names.py
 *
 * 서버 S_NpcPack은 이름 자리에 `npcs.name_id`를 보내는데 그 값이 비어 있는 NPC가
 * 179종 있다. 이름이 비면 화면에 'M' 한 글자만 남으므로, **gfxId로 이름을 되찾는
 * 폴백**으로 쓴다. 서버가 이름을 제대로 보냈다면 그쪽이 항상 우선이다.
 *
 * 값은 칭호(`"이름^칭호"`의 `^` 뒷부분)를 뗀 표시용 이름이다.
 * 한 gfxId를 여러 NPC가 나눠 쓰면 가장 흔한 이름이 들어 있다.
 */
export const NPC_NAME_BY_GFX: Readonly<Record<number, string>> = {
  0: '블랙 티거',
  1: '아덴성의 공주',
  29: '괴물 눈',
  30: '해골',
  31: '도펠 갱어',
  32: '엘더',
  49: '돌 골렘',
  52: '좀비',
  53: '바포메트',
  54: '난쟁이',
  55: '개구리',
  56: '오크',
  86: '불꽃 (소)',
  87: '불꽃 (소)',
  95: '셀로브',
  96: '늑대',
  98: '고대의 도구 상인',
  100: '군터',
  102: '독수리',
  114: '허수아비',
  116: '허수아비',
  118: '발심',
  120: '무기 부대',
  134: 'rune wall',
  136: 'rune wall',
  144: '난폭 한 구울',
  145: '스파 토이',
  146: '웅 골리 언트',
  148: '가이드',
  152: '버그 베어',
  155: '시련의 수정',
  168: '파이어 월',
  173: '카스파',
  176: '아이스 랜스',
  183: '흑 장로',
  185: '발타자르',
  187: '멜키 오르',
  200: '케티',
  234: '룻',
  237: '게렝',
  240: '데스 나이트',
  246: '크로 울링 크로',
  255: '가스트',
  257: '가스트로드',
  261: '록',
  264: 'rune wall',
  266: '오림',
  335: '가이드',
  361: 'fountain',
  457: '디코',
  460: '타운 어드바이저',
  695: '시반',
  696: '말콤',
  697: '랄프',
  698: '타이 러스',
  699: '리나',
  700: '베리',
  701: '샤윈',
  702: '존',
  703: '페리아',
  704: '베릭',
  705: '휜',
  706: '쥬디스',
  721: '가스',
  723: '카 미트',
  725: '누가',
  727: '토마',
  779: 'l temple water',
  780: '처음부터의 소리',
  782: '장로 노나메',
  784: '간디 오크',
  786: '아 투바 오크',
  788: '오크 밀사',
  790: '오크 스카우트',
  792: '쿠퍼',
  793: '콥',
  794: '번치',
  796: '루니',
  797: '데이지',
  798: '엘룬',
  799: '비온',
  800: '콜롯세움 부 관리인',
  824: '오크 근위병',
  826: '골키퍼',
  834: '아라스',
  841: '플라워 숍 \'향기의 집\'',
  843: '무기 상점 \'기적의 집\'',
  847: '엔트',
  851: '오염 된 엔트',
  852: '펑 거스',
  854: '페어리',
  864: '아라크네',
  865: '숲의 수호자',
  868: 'SIC의 광 2 개',
  869: '숲과 요정의 어머니',
  874: '빛',
  875: '판',
  894: '킹 버그 베어',
  895: '네루 파',
  896: '페어리 퀸',
  914: '샤론',
  916: '오스',
  918: '엘',
  924: '로베르토',
  929: '세인트 버나드',
  931: '도베르만',
  934: '콜리',
  936: '세퍼드',
  938: '비글',
  940: '왕궁 게이트 키퍼',
  941: '돼지',
  943: '암탉',
  945: '젖소',
  947: '사슴',
  949: '혈맹 집행 인',
  951: '공포의 켈베로스',
  971: '마을 관리인',
  979: '멧돼지',
  981: '마크',
  982: '한스',
  983: '루디안',
  984: '글렌',
  985: '리온',
  986: '커스',
  987: '티오',
  988: '빅터',
  989: '앨리',
  990: '멜린',
  991: '루키',
  992: '콜롯세움 관리인',
  994: '게 라드',
  998: '토끼',
  999: '토끼',
  1002: '토끼',
  1003: '토끼',
  1011: '劫火',
  1014: '오리',
  1020: '오우거',
  1022: '시련의 고블린',
  1024: '하피',
  1036: '개미 던전 입구',
  1037: '거대 개미',
  1039: '거대 병정 개미',
  1041: '바실리스크',
  1045: '듀론',
  1047: '스콜피온',
  1049: '클레이',
  1052: '코카 트리스',
  1055: '저수지',
  1059: '코볼트',
  1062: '스타이 저',
  1082: '무리 안',
  1093: 'treasure chest',
  1094: 'pigeon group',
  1096: '해골 궁수',
  1098: '트롤',
  1104: '해골 도끼 병',
  1106: '해골 창병',
  1108: '라이칸 스로프',
  1110: '늑대 인간',
  1112: '서큐버스',
  1116: '서큐버스 퀸',
  1121: '오크 좀비',
  1123: '사악한 비홀더',
  1125: '다크 엘프',
  1128: '에틴',
  1130: '난폭 한 해골 저격병',
  1132: '해골 돌격 병',
  1134: '해골 근위병',
  1150: '아이들 론',
  1152: '임프',
  1154: '그렘린',
  1158: '임프 장로',
  1162: '아울 베어',
  1171: '불',
  1172: 'SIC의 광 1 개',
  1173: '리자드 맨',
  1180: '爆炎',
  1184: '드워프 센티넬',
  1202: '사이클롭스',
  1204: '그리폰',
  1206: '홉 고블린',
  1208: '워너',
  1211: '오크 장로',
  1216: '아덴 상단',
  1222: '레인저',
  1236: '사슴',
  1243: '카드 무스',
  1245: '바모스',
  1250: '레인저',
  1254: '데렉',
  1256: '경매 관리자',
  1266: '아만다',
  1268: '알폰스',
  1271: '노세',
  1273: '비련',
  1276: '필립',
  1278: '루푸스',
  1280: '디마',
  1282: '데칸',
  1284: '공성 깃발',
  1286: '헬렌',
  1288: '가르',
  1290: '멘델',
  1294: '라반',
  1296: '에버트',
  1298: '메린',
  1301: '루바',
  1305: '루케 인',
  1307: '모리아',
  1312: '허버트',
  1314: '버질',
  1318: '유령',
  1321: '유령',
  1390: '거대 여왕 개미',
  1449: '기란 깃발',
  1450: '기란 깃발',
  1477: '놀',
  1479: '미믹',
  1482: '왕관',
  1505: '폴리',
  1506: '살리나',
  1507: '몰리',
  1508: '알리',
  1509: '베르 마',
  1510: '제노',
  1511: '에반',
  1512: '치료사',
  1513: '네일',
  1514: '듀발',
  1515: '딕',
  1517: '미노타우르스',
  1525: '아이스 골렘',
  1528: '하로',
  1529: '에블린',
  1530: '아리에',
  1531: '릴',
  1532: '에니 시​​아',
  1533: '프랑코',
  1538: '페이퍼 맨',
  1540: '여우',
  1542: '자이언트',
  1544: '게시판',
  1546: '게시판',
  1555: '자이언트',
  1557: '게시판',
  1559: '게시판',
  1569: '자이언트',
  1571: '실루엣',
  1572: '크로커다일',
  1574: '악어',
  1576: '데스',
  1578: '리빙 아머',
  1580: '인어',
  1584: '시호 스',
  1586: '말미잘',
  1590: '파 푸리 온',
  1595: '바쿡',
  1597: '라미아',
  1600: '라미아',
  1603: '시 댄서',
  1610: '크랩 맨',
  1612: '랫맨',
  1614: '혈거 인간',
  1616: '일 렉카 둠',
  1619: '베아사무',
  1621: '마르',
  1623: '가오리',
  1626: '머맨',
  1628: '실라칸스',
  1630: '화소 · 오렌지',
  1632: '크러스트 시안',
  1634: '물고기',
  1636: '해파리',
  1638: '해파리',
  1640: '물고기',
  1642: '곰',
  1644: '상어',
  1646: '아 스테',
  1648: '화대 · 오렌지',
  1649: '터틀 드래곤',
  1653: '물고기',
  1655: '물고기',
  1657: '물고기',
  1659: '근위병',
  1666: '사라만다',
  1670: 'central_fountain',
  1672: '수호탑',
  1678: 'siksudea b',
  1681: 'siksudea c',
  1684: '에바의 신전 마루',
  1702: 'H Fountain_B_n',
  1705: '하이네 도시의 풍차',
  1707: '하이네 도시의 풍차',
  1710: '하이네 도시의 풍차',
  1719: 'H Fountain_B_n',
  1720: 'H Fountain_B_n',
  1721: 'H Fountain_B_n',
  1722: 'H Fountain_B_n',
  1723: 'H Fountain_B_n',
  1724: 'H Fountain_B_n',
  1725: 'H Fountain_B_n',
  1726: 'H Fountain_B_e',
  1727: 'H Fountain_B_s',
  1728: 'H Fountain_B_n',
  1758: '마법의 벽',
  1759: '에바의 신전의 하수구',
  1762: '라바 골렘',
  1766: '포 템핀',
  1768: '쿠프',
  1770: '불타는 전사',
  1773: '이프리트',
  1780: '혼 켈베로스',
  1791: '피닉스',
  1820: '파이어 에그',
  1828: '폭탄 꽃',
  1832: '불타는 궁수',
  1841: '화염의 아시타 지오',
  1844: '드래곤 플라이',
  1995: '크리스마스 트리 (옛 마을) 날',
  1997: '골키퍼',
  2001: '발라카스',
  2060: '타 라스',
  2064: '눈사람',
  2084: '허수아비',
  2086: '냉혹 한 샤벨 타이거',
  2090: '연금술사',
  2112: '엘모어 마법사',
  2115: '엘 뤼온',
  2118: '얼음의 여왕 시녀',
  2134: '에티',
  2137: '좀비 엘모어 장군',
  2139: '몽 테스',
  2141: '성향 치 회복',
  2143: '강화 마법사',
  2145: '허스키',
  2147: '공포의 아이언 골렘',
  2150: '좀비 엘모어 병사',
  2158: '아이스 맨',
  2205: '게시판',
  2207: '게시판',
  2231: '라이프 스트림',
  2240: '페이퍼 맨',
  2255: '파우',
  2266: '불의 대 정령',
  2267: '땅의 대 정령',
  2268: '물의 정령',
  2273: '땅의 정령',
  2274: '물의 정령',
  2275: '바람의 정령',
  2276: '불의 정령',
  2282: '바람의 대 정령',
  2289: '아덴 가드',
  2293: '마크',
  2295: '아덴 가드',
  2299: '도구 류',
  2302: '오두막의 지붕',
  2308: '가고일',
  2314: '루즈',
  2332: '나이트 메어',
  2335: '아덴 근위병',
  2337: '리키',
  2340: '도펠 갱어',
  2350: '리자드 맨',
  2351: '라미아',
  2352: '용감한 라미아',
  2353: '그리폰',
  2354: '악어',
  2355: '악어',
  2356: '짐승',
  2357: '버그 베어',
  2358: '킹 버그 베어',
  2359: '바실리스크',
  2360: '코카 트리스',
  2361: '사이클롭스',
  2362: '드레이크',
  2363: '하피',
  2364: '미노타우르스',
  2365: '미노타우르스',
  2366: '라이칸 스로프',
  2367: '늑대 인간',
  2368: '아울 베어',
  2369: '셀로브',
  2370: '웅 골리 언트',
  2371: '트롤',
  2372: '가스트',
  2373: '가스트로드',
  2379: '레서 드래곤',
  2382: '아덴 근위병',
  2389: '도펠 갱어',
  2392: '다이어 울프',
  2398: '도일',
  2400: '텔레 포터',
  2402: '그레이트 미노타우르스',
  2405: '라파엘',
  2407: '키메라',
  2409: '본 드래곤',
  2417: '산적 두목 클라인',
  2419: '켄 라우헬',
  2421: '트라이 서울',
  2429: '제프',
  2435: '다크 엘프',
  2436: '짐',
  2437: '델피',
  2438: '터널 개미',
  2443: '기란 산적',
  2457: '변종 거대 여왕 개미',
  2460: '거대 개미 위치',
  2466: '스빈',
  2468: '케레니스',
  2487: '무기 강화 사',
  2489: '기란 산적',
  2495: '리치',
  2499: '잭 오 랜턴',
  2501: '저주받은 할로윈 허수아비',
  2503: 'fountain d aden',
  2504: 'fountain c aden',
  2505: '마틸다',
  2510: '침묵의 동굴의 빛',
  2511: '모네 뜨',
  2513: '댄싱 소드',
  2516: '기란 산적',
  2524: '레서 데몬',
  2529: '슈인',
  2531: '딜런',
  2533: '기란 산적',
  2535: '메두사',
  2538: '발록의 분신',
  2541: '젤라틴 큐브',
  2544: '린드 비 오르',
  2648: '골키퍼',
  2649: '에노',
  2650: '가이드',
  2665: '수호탑 : 파 아그 리오',
  2667: '수호탑 : 마 프르',
  2669: '수호탑 : 에바',
  2671: '수호탑 : 사 이하',
  2674: '수호탑',
  2711: '자이언트 장로',
  2712: '세피아',
  2714: '자이언트 가디언',
  2716: '고대의 망령',
  2724: '지무',
  2725: '신비한 바위',
  2727: '볼 라이트닝',
  2738: '물의 대 정령',
  2741: '바람의 대 정령',
  2747: '불의 대 정령',
  2749: '땅의 대 정령',
  2752: '꿈의 혼령',
  2755: '유니콘',
  2757: '공포의 뱀파이어',
  2763: '발록의 추종자',
  2765: '블루 디카',
  2767: '디 가르뎅',
  2771: '가디언 아머',
  2773: '시어 주니어',
  2778: '라무 다',
  2779: '세리아',
  2781: '에들 렌',
  2788: '킬러 비',
  2792: '랑스',
  2794: '리앤',
  2801: '제티',
  2803: '공포의 좀비로드',
  2807: '제니스 퀸',
  2811: '페스 코',
  2813: '데린',
  2820: '이리스',
  2822: '침묵의 동굴의 빛',
  2823: '침묵의 동굴의 빛',
  2824: '침묵의 동굴의 빛',
  2825: '침묵의 동굴의 빛',
  2826: '침묵의 동굴의 빛',
  2827: '침묵의 동굴의 빛',
  2828: '침묵의 동굴의 빛',
  2829: '로제',
  2831: '침묵의 동굴의 빛',
  2832: '침묵의 동굴의 빛',
  2833: '침묵의 동굴의 빛',
  2834: '침묵의 동굴의 빛',
  2835: '침묵의 동굴의 빛',
  2836: '침묵의 동굴의 빛',
  2837: '침묵의 동굴의 빛',
  2839: '침묵의 동굴의 빛',
  2840: '침묵의 동굴의 빛',
  2841: '침묵의 동굴의 빛',
  2842: '침묵의 동굴 결정',
  2843: '어쌔신 마스터',
  2846: '침묵의 동굴의 빛',
  2847: '침묵의 동굴의 빛',
  2848: '침묵의 동굴의 빛',
  2852: '침묵의 동굴의 빛',
  2853: '침묵의 동굴의 빛',
  2854: '침묵의 동굴의 빛',
  2855: '침묵의 동굴의 빛',
  2856: '침묵의 동굴의 빛',
  2857: '침묵의 동굴의 빛',
  2862: '침묵의 동굴의 빛',
  2863: '침묵의 동굴의 빛',
  2864: '침묵의 동굴의 빛',
  2865: '침묵의 동굴의 빛',
  2885: '박쥐',
  2887: 'butterfly',
  2889: 'butterfly',
  2891: 'butterfly',
  2907: '로덱',
  2917: '이카',
  2963: '칸의 말',
  2964: '론드의 말',
  2966: '어쌔신',
  2972: '꿈의 혼령',
  2973: '꿈의 혼령',
  2974: '꿈의 혼령',
  2975: '꿈의 혼령',
  2976: '다크 엘프 레인저',
  2977: '키마',
  2978: '칸의 경비병',
  2992: '허수아비',
  3044: '다크 엘프 솔저',
  3049: '쿠거',
  3066: '나이트 발드',
  3073: '마계의 타락한 영혼',
  3083: '죽음의 사제',
  3086: '머미로드',
  3089: '혼돈의 사제',
  3092: '감독 리퍼',
  3095: '류미엘',
  3097: '엔디 아',
  3101: '커츠',
  3103: '발록의 분신',
  3107: '하이 허스키',
  3132: '하이 도베르만',
  3134: '고양이',
  3136: '메티스의 근위대',
  3143: '하이 비글',
  3154: '하이 래빗',
  3156: '하이 폭스',
  3178: '하이 캣',
  3180: '아이리스',
  3182: '하이 세인트 버나드',
  3184: '하이 세퍼드',
  3188: '하이 베어',
  3191: '크리스마스 트리 (아지트)',
  3195: '타락의 사제',
  3199: '하이 울프',
  3201: '크리스마스 트리 (성)',
  3211: '하이 콜리',
  3232: '조드',
  3235: '로우 기',
  3351: 'ghoul dungeon gate',
  3357: '다이어 베어',
  3360: '다크 엘리멘탈리스트',
  3364: '다크 엘리멘탈',
  3365: '그레이터 다크 엘리멘탈',
  3366: '다크 엘프 제너럴',
  3376: '다크 엘프 위저드',
  3380: '타락한 영혼',
  3387: '사신 그림 리퍼',
  3391: '그림 리퍼',
  3402: '다크 엘프 가드',
  3404: '다크 엘프 가드',
  3406: '야히의 분신',
  3409: '다크 엘프 비스트 테이머',
  3412: '다크 엘프 시프',
  3415: '다이어 뱃',
  3418: '속박 된 영혼',
  3420: '론도',
  3447: '게라도 용병대',
  3448: '돌격 단장',
  3449: '경비 병사',
  3450: '경비 병사',
  3454: '경비 대장',
  3478: '미니 버그 베어',
  3497: '플루트',
  3498: '토토',
  3499: '버기',
  3500: '올',
  3501: '제프리',
  3502: '카이',
  3503: '아돌프',
  3504: '오바훗토',
  3505: '란뿌스',
  3506: '카',
  3507: '글루코',
  3508: '쿤도라',
  3509: '쿠마토',
  3510: '두렛쿠',
  3511: '구로돈',
  3512: '쿠ェ니바',
  3520: 'magic box left npc',
  3547: '블랙 티거',
  3566: '서먼 엘리멘탈',
  3568: '딥 플라워',
  3582: '두더지',
  3590: '수감중인 다크 엘프',
  3592: '수감중인 다크 엘프',
  3596: '헤비 오움',
  3636: '광부 오움',
  3638: '도망친 오움',
  3640: '도망친 오움',
  3642: '광부 오움',
  3644: '미들 오움',
  3652: '딜로',
  3654: '플레이트 웜',
  3659: '수송 다크 엘프',
  3661: '장로 오움',
  3664: '마수 군왕 바란카',
  3678: '블랙 엔트',
  3694: '비스트 서머너',
  3698: '암흑 마법사',
  3744: '라이아',
  3747: '어둠 숲지기',
  3757: '레이더',
  3783: '열혈 토끼',
  3788: '아덴 정찰병',
  3800: '광부 오움',
  3801: '아덴 정찰병',
  3860: '오크 궁수',
  3864: '오크 전사',
  3867: '배신당한 오크 대장',
  3890: '다크 나이트',
  3891: '다크 매지 스터',
  3892: '다크 레인저',
  3893: '실버 나이트',
  3894: '실버 매지 스터',
  3895: '실버 레인저',
  3896: '소드 마스터',
  3897: '마법사 리 마스터',
  3898: '애로우 마스터',
  3899: '아크 나이트',
  3900: '아크 마법사',
  3901: '아크 스카우터',
  3912: '기란 임프',
  3914: '기란 돌 골렘',
  3916: '기란 다이어 울프',
  3918: '기란 샤벨 타이거',
  3920: '바쿡',
  3922: '기란 키메라',
  3926: '기란 임프 장로',
  3928: '기란 가스트',
  3930: '기란 가스트로드',
  3946: '라 블라',
  3948: '라 보르',
  3957: '타락의 사제',
  3969: '타락의 사제',
  3984: '타락의 사제',
  3989: '타락의 사제',
  4003: '흑기사',
  4005: '심연의 구울',
  4007: '씽',
  4009: '화염의 이빨',
  4010: '빙하의 이빨',
  4011: '바람의 이빨',
  4012: '대지의 이빨',
  4013: '화령의 주인',
  4017: '시 댄서',
  4024: '풍령의 주인',
  4025: '심연의 화령',
  4028: '심연의 수령',
  4029: '심연의 풍령',
  4030: '심연의 지령',
  4034: '邪炎',
  4038: '라쿤',
  4041: '지령의 주인',
  4043: '고대 자이언트 장로',
  4045: '고대 자이언트 장군',
  4047: '정령의 오브',
  4051: '무덤 가디언 메이지',
  4058: '스콜피온',
  4060: '다크 샌드 전갈',
  4068: '타락',
  4078: '블루 테일',
  4083: '사라만다',
  4086: '무리 안',
  4088: '나이트 메어',
  4091: '서큐버스',
  4095: '데스',
  4097: '메두사',
  4100: '켈베로스',
  4104: '뱀파이어',
  4121: '혼 켈베로스',
  4125: '심연의 궁수',
  4127: '시미즈',
  4133: '하이 라쿤',
  4137: '도일',
  4141: '모네 뜨',
  4145: '브리',
  4147: '키위 패롯',
  4149: '매드 리자드 맨',
  4151: '헤비 리자드 맨',
  4153: '레스타',
  4168: '맘보 토끼',
  4171: '맘보 토끼',
  4183: '쇼크 스턴',
  4185: 'black-rune',
  4186: '라버 본',
  4188: '라버 본 헤드',
  4190: '라버 본 솔져',
  4192: '하이 리자드 맨',
  4203: '와일드 매직',
  4205: '와일드 베놈',
  4207: '와일드 팡',
  4209: '무덤 가디언',
  4212: '무덤 가디언 나이트',
  4215: '거대한 무덤 가디언',
  4218: '드레이크 선장',
  4258: '래리',
  4259: '래리의 보좌관',
  4260: '래리의 병사',
  4261: '레서 데몬',
  4262: '발록의 분신',
  4263: '칼 바스의 하인',
  4306: '수감 된 아덴 용병',
  4307: '수감 된 아덴 용병',
  4308: '밧슈',
  4309: '수감 된 아덴 용병',
  4310: '로이',
  4312: '보보',
  4359: '고대의 정령',
  4363: '래리의 말',
  4364: '오염 된 딥 플라워',
  4366: '작은 상자',
  4368: '도일의 개',
  4369: '아덴 정보원',
  4403: '오염 된 바람의 대 정령',
  4404: '오염 된 물의 대 정령',
  4405: '오염 된 불의 대 정령',
  4407: '오염 된 빛의 대 정령',
  4408: '오염 된 땅의 대 정령',
  4410: '오염 된 어둠의 대 정령',
  4417: '오염 된 인간',
  4420: '오염 된 인간 _4',
  4423: '오염 된 인간 _3',
  4426: '오염 된 인간 _2',
  4429: '오염 된 엘프',
  4457: '오염 된 오크',
  4460: '오염 된 오크 도끼 병',
  4463: '오염 된 오크 궁수',
  4466: '아리 오크',
  4472: '오염 된 오크 전사',
  4475: '오염 된 오크 창병',
  4493: '스피 리드',
  4502: '스피 리드의 소환물',
  4516: '숲의 수호자',
  4517: '탐욕스런 마법사',
  4519: '굶주린 간수',
  4521: '혼돈의 사제',
  4527: '암살 군왕 슬레이브',
  4531: '굶주린 간수',
  4533: '명법 군왕 헬 바인',
  4542: '타이거',
  4544: '혼돈의 사제',
  4550: '혼돈의 사제',
  4559: '탐욕스런 전사',
  4561: '백작 친위대 장',
  4563: '죽음의 사제',
  4569: '야히',
  4574: '죽음의 사제',
  4576: '죽음의 사제',
  4582: '진돗개',
  4587: '죽음',
  4595: '혼돈',
  4603: '어둠의 복수 자',
  4609: '라스타바드 근위대',
  4612: '야히',
  4615: '핏빛 기사',
  4618: '암살 단장 블레이즈',
  4622: '헬 크리쳐',
  4625: '라스타바드 근위대',
  4632: '물의 정령 수호자',
  4633: '불의 정령 수호자',
  4634: '땅의 정령 수호자',
  4643: '헬 바운드',
  4649: '크림슨 드레이크',
  4652: '죽음의 사제',
  4657: '어둠의 군주',
  4664: '팬텀 나이트',
  4667: '장로 수행원',
  4670: '피의 강령 술사',
  4677: '디에고',
  4680: '프랑코',
  4684: '거대 쥐',
  4689: '오움 전사',
  4691: '카미 라의 유령',
  4693: '죽음의 사제',
  4698: '호세',
  4701: '친위대 장 카이트',
  4708: '리자드 맨 장로',
  4738: '돌연변이 크랩 맨',
  4740: '경비견',
  4744: '헤비 오움 전사',
  4746: '쿠만',
  4753: '도펠 갱어',
  4771: '돌연변이 리자드 맨',
  4786: '바람 정령 수호자',
  4787: '어둠 정령 수호자',
  4788: '돌연변이 머맨',
  4790: '맘몬',
  4796: '라버 본 나이프',
  4820: '돌연변이 라이칸 스로프',
  4822: '돌연변이 늑대 인간',
  4825: '공간의 일그러짐',
  4851: '타로스 백작',
  4854: '사단장 싱클레어',
  4855: '마법 단장 카르 미엘',
  4867: '아이언 골렘',
  4873: '연구원',
  4874: '선택받지 못한 자',
  4876: '선택받지 못한 자',
  4877: '선택받지 못한 자',
  4880: '야히',
  4881: '선택받지 못한 자',
  4882: '선택받지 못한 자',
  4910: '돌 골렘',
  4912: '마이 노 샤먼의 다이아몬드 골렘',
  4915: '아이스 맨',
  4930: '굶주린 간수',
  4935: '부패한 좀비 장군',
  4937: '부패한 좀비 마법사',
  4942: '마이 노',
  5007: '리자드 맨 청년 전사',
  5008: '발바 도스',
  5014: '부패한 해골 도끼 병',
  5033: '부패한 해골 창병',
  5065: '아기 진돗개',
  5072: '마이 노 샤먼',
  5089: '배틀 타이거',
  5107: '마이 노 샤먼의 라바 골렘',
  5110: '굶주린 죄인',
  5112: '굶주린 죄인',
  5127: '부패한 해골 궁수',
  5212: '블랙 위자드',
  5259: '튜폰',
  5265: '角炎',
  5269: '獣炎',
  5274: '대법관 티아 메스',
  5282: '와이번',
  5284: '대법관 라미 아스',
  5289: '심해어',
  5293: '대법관 엔디 아스',
  5297: '대법관 이데아',
  5317: '바람의 시버 인',
  5324: '파도의 시버 인',
  5331: '불의 시버',
  5338: '흙의 시버 인',
  5348: '리빙 아머',
  5351: '디고',
  5353: '주디 고',
  5365: '대법관 비아 타스',
  5373: '대법관 케이 나',
  5405: '뼈 뱀장어',
  5412: '익사 한 여성',
  5442: '오튜',
  5447: '저주받은 무녀 사엘',
  5454: '진명 황 단테스',
  5456: '차원의 문',
  5457: '차원의 문',
  5458: '차원의 문',
  5459: '차원의 문',
  5460: '차원의 문',
  5461: '파사 즈',
  5463: '파사 즈',
  5471: '대법관 바로 드',
  5478: '대법관 바로 메스',
  5484: '익사 한 남성',
  5507: '발록',
  5511: '발록',
  5516: '저주받은 다크 엘프 메이지',
  5547: '대왕 오징어',
  5554: '반어 인',
  5567: '장로 수행원',
  5574: '모래 무덤',
  5596: '피의 암살자',
  5620: '기르 타스',
  5645: '잭 오 랜턴',
  5655: '파즈',
  5657: '파즈',
  5676: '버려진 육신',
  5677: '마야의 소환물',
  5683: '오염 된 사이클롭스',
  5684: '오염 된 페어리',
  5685: '오염 된 펑 거스',
  5687: '오염 된 오우거',
  5688: '오염 된 트롤',
  5689: '오염 된 간디 오크',
  5690: '오염 된 두다 - 마라 오크',
  5691: '오염 된 오크 전사',
  5693: '저주받은 다크 엘프 메이지',
  5694: '저주받은 다크 엘프 투사',
  5695: '저주받은 다크 엘프 기사',
  5708: '우두머리 반어 인',
  5723: '장로 수행원 쿠로렌스',
  5724: '저주받은 다크 엘프 기사',
  5739: '저주받은 다크 엘프 메이지',
  5742: '저주받은 다크 엘프 기사',
  5745: '저주받은 다크 엘프 기사',
  5751: '저주받은 다크 엘프 투사',
  5754: '저주받은 다크 엘프 투사',
  5760: '저주받은 다크 엘프 마법사',
  5767: '세루 만',
  5778: '저주받은 다크 엘프 투사',
  5781: '저주받은 다크 엘프 투사',
  5786: '자이언트 웜',
  5802: '자이언트 히드라',
  5815: '켄투 네루가',
  5816: '오크 밀사',
  5817: '네루가 바쿠 모',
  5818: '카푸',
  5900: '텔레 포터',
  5912: '현상범 쿠작',
  5913: '에 마이',
  5919: '서큐버스 마법 인형',
  5933: '로드 마법 인형',
  5937: '마야의 그림자',
  5938: '오크 밀사 리더',
  5939: '오염 된 오크 마법사',
  5946: '데스 매치 관리인 다투',
  5955: '치안 대장 라르손',
  5957: '요리사',
  5969: '파우스트의 악령',
  5972: '파우스트의 악령',
  5977: '파우스트의 악령',
  5979: '원한에 찬 하멜 장군',
  6036: '제단',
  6078: '아덴 기마 단원',
  6083: '먼 연구원',
  6096: '늑대 인간 마법 인형',
  6100: '버그 베어 마법 인형',
  6120: '오염 된 브롭',
  6161: '산성 개미 무리',
  6171: '케 플리 샤',
  6232: '항목 제작사',
  6239: '항목 제작사',
  6245: '제 인트',
  6246: '마르코',
  6252: '낚시터 가이드',
  6290: '거대 수호 개미',
  6302: '거대 산성 개미',
  6310: '아기 판다 곰',
  6314: '공포의 판다 곰',
  6322: '불꽃의 캥거루',
  6325: '아기 캥거루',
  6345: '개미의 알',
  6348: '개미의 알',
  6377: '리올',
  6396: '골드 드래곤',
  6399: '할로윈 마을의 사자',
  6443: '장로 마법 인형',
  6449: '크러스트 시안 마법 인형',
  6452: '돌 골렘 마법 인형',
  6477: '시 댄서 마법 인형',
  6480: '예티 마법 인형',
  6483: '라미아 마법 인형',
  6552: '본 브레이크',
  6555: '테베 만드라고라',
  6557: '테베 만드라고라',
  6558: '얼음 여왕 근위병',
  6560: '얼음 여왕 근위병',
  6562: '테 베니 바스',
  6563: '테 베니 바스',
  6566: '아이스 데몬',
  6569: '테베 호루스',
  6581: '얼음 여왕',
  6592: '테베 갑충 석',
  6593: '테베 갑충 석',
  6595: '테베 아누비스',
  6601: '테베 칼 비스',
  6603: '테베 칼 비스',
  6632: '아울 베어',
  6634: '아울 베어',
  6636: '라이칸 스로프',
  6638: '아이언 골렘',
  6645: '테베 오벨리스크',
  6649: '테베 오벨리스크',
  6653: '테베 니아 무스',
  6654: '테베 니아 무스',
  6664: '테 베니 호스',
  6665: '테 베니 호스',
  6685: '항목 제작사',
  6690: '마법 판매자',
  6699: '테베 스핑크스',
  6704: '테베 스핑크스',
  6706: '큐브 [점화]',
  6709: 'rune',
  6712: '큐브 [퀘이크]',
  6718: '큐브 [충격]',
  6724: '큐브 [균형]',
  6757: '대장장이',
  6768: '이상한 텔레 포터',
  6773: '행정관 키호루',
  6776: '좀비 엘모어 마샬',
  6778: '강풍 샤스키',
  6781: '장로 프로 켈',
  6786: '붉은 영혼의 불꽃',
  6788: '사비우스',
  6793: '에루 라스',
  6804: '유리에',
  6892: '재생의 제단',
  6899: '텔레 포터',
  6901: '화이트 개미 시체',
  6909: '화이트 개미의 흔적 (산성 액)',
  6910: '화이트 개미의 흔적 (달걀 껍질)',
  6918: '화이트 개미의 흔적 (토)',
  6919: '시간의 균열',
  6920: '시간의 균열',
  6968: '라르크',
  6977: '아제 루',
  6986: '대장장이',
  6989: '마법 판매자',
  6992: '테베 오시리스 제단 골키퍼',
  7001: '장로 시루 레인',
  7008: '가이드',
  7009: '텔레 포터',
  7010: '타 리온',
  7016: '가이드',
  7017: '가이드',
  7019: '가이드',
  7047: '코카 트리스 마법 인형',
  7050: '허수아비 마법 인형',
  7078: '에쿠 아즈 테',
  7081: '에쿠 아즈 테',
  7091: '에쿠유카',
  7097: '에쿠유카',
  7098: '에쿠 쥬라 카',
  7099: '에쿠 쥬라 카',
  7111: '에쿠부라',
  7113: '에쿠부라',
  7167: '에쿠엣토',
  7170: '에쿠엣토',
  7173: '쟈도토우',
  7176: '쟈도토우',
  7184: '자드 스케',
  7186: '자드 스케',
  7193: '자드 테오',
  7196: '자드 테오',
  7197: '스네이크',
  7220: '젊은 원숭이',
  7234: '제부레쿠이',
  7236: '제부레쿠이',
  7257: '스파 토이 마법 인형',
  7260: '젊은 원숭이',
  7263: '쿠 쿨칸 제단 골키퍼',
  7285: '슈퍼 멍키',
  7335: '드워프 제너럴',
  7342: '천리안 신명',
  7348: '마조 신',
  7351: '큰 도깨비 신명',
  7362: '드워프 주술사',
  7365: '해츨링',
  7369: '해츨링',
  7372: '유키',
  7391: 'rune wall',
  7392: 'rune wall',
  7393: 'rune wall',
  7394: 'rune wall',
  7407: '케레니스',
  7463: '하딘',
  7480: 'magic-boll',
  7481: '코마유무',
  7489: '코마신',
  7496: '코마 쿰',
  7503: '코마 쿰',
  7509: '코마 쿰',
  7515: '파우스트',
  7516: '도플 갱어 마법 인형',
  7522: '용의 계란',
  7531: '용의 계란',
  7534: 'wall',
  7535: 'wall',
  7536: 'wall',
  7537: 'wall',
  7539: '안타라스',
  7548: '드래곤 포탈',
  7550: '드래곤 포탈',
  7552: '드래곤 포탈',
  7554: '용의 전령',
  7557: '안타라스',
  7558: '안타라스',
  7559: '테라 드래곤 (불)',
  7566: '테라 드래곤',
  7567: 'magic-boll',
  7572: '휴식 포인트',
  7573: '테라 드래곤 (바람)',
  7580: '테라 드래곤 (물)',
  7585: '드래곤 포탈',
  7587: '유니 드래곤 (불)',
  7590: '유니 드래곤 (지)',
  7593: '유니 드래곤 (바람)',
  7596: '유니 드래곤 (물)',
  7604: '하이 아주르 해츨링',
  7609: '하이 크림슨 해츨링',
  7618: '드루가 가방 판매 인',
  7655: '드워프 가드',
  7656: '상인',
  7657: '상점',
  7658: '해츨링 교환 사람',
  7659: '하이 해츨링 마법 인형 아주르',
  7660: '하이 해츨링 마법 인형 크림슨',
  7661: '해츨링 마법 인형 크림슨',
  7662: '해츨링 마법 인형 아주르',
  7684: '오색 진주',
  7719: '토루나루',
  7723: '우구 누스',
  7745: '아로호스메가',
  7762: '추가 창고',
  7764: '아로호스비아',
  7784: '아로호스네로',
  7786: '아로호스네로',
  7788: '아로호스네로',
  7805: '最果ての輝宝',
  7845: '케레니스',
  7847: '케레니스',
  7860: '포탄',
  7862: '커다란 조개',
  7864: '파 푸리 온',
  7868: '초보자 가이드',
  7869: '파 푸리 온',
  7870: '파 푸리 온',
  7904: '사엘',
  7905: '코트 제비',
  7934: '뻬루뻬루',
  7939: '페르 티아 가루다 A',
  7940: '페르 티아 가루다 B',
  7941: '페르 티아 가루다 C',
  7959: '창천의 기사',
  7989: '메탈 골렘 (수)',
  7992: '메탈 골렘 (바람)',
  7995: '메탈 골렘 (화)',
  7998: '메탈 골렘 (地)',
  8036: '린드 비 오르',
  8055: '린드 비 오르',
  8056: '린드 비 오르',
  8087: '구름의 대 정령',
  8096: '수상한 암운',
  8126: '시 하피',
  8128: '시드 레이크',
  8162: '공지 사항 소년',
  8168: '세마',
  8175: '피닉스',
  8239: '크라켄',
  8334: '항목 제작사',
  8338: '마계의 혼돈의 사제',
  8457: '타락한 영혼',
  8459: '다크 좀비 엘모어 장군',
  8470: '올 딘',
  8479: '날개가 돋아 난 미믹 상자',
  8539: '자이언트 마법 인형',
  8542: '빛나는 자이언트 마법 인형',
  8543: '노력하는 거대한 마법 인형',
  8544: '현명한 자이언트 마법 인형',
  8545: '눈부신 자이언트 마법 인형',
  8546: '똑똑한 자이언트 마법 인형',
  8549: '사이클롭스 마법 인형',
  8600: '빛나는 사이클롭스 마법 인형',
  8601: '노력하는 사이클롭스 마법 인형',
  8602: '눈부신 사이클롭스 마법 인형',
  8603: '현명한 사이클롭스 마법 인형',
  8650: '인어 마법 인형',
  8653: '빛나는 인어 마법 인형',
  8656: '눈부신 인어 마법 인형',
  8694: '노력하는 인어 마법 인형',
  8695: '현명한 인어 마법 인형',
  8696: '똑똑한 인어 마법 인형',
  8697: '똑똑한 사이클롭스 마법 인형',
  8741: '짐승 마법 인형',
  8743: '빛나는 에틴 마법 인형',
  8744: '눈부신 짐승 마법 인형',
  8748: '노력하는 짐승 마법 인형',
  8749: '영리한 짐승 마법 인형',
  8750: '똑똑한 짐승 마법 인형',
  8751: '눈싸움 요정',
  8774: '영 케레니스',
  8812: '얀구군타',
  8817: '영 켄라우헬',
  8851: '영 단테스',
  8900: '영 헬 바인',
  8913: '영 질리언',
  8978: '영 블루 디카',
  9003: '얀구조우',
  9218: '그림자 슬립',
  9377: '마법사 마법 인형',
  9381: '마법사 마법 인형',
  9385: '용 기사 마법 인형',
  9388: '용 기사 마법 인형',
  9391: '다크 엘프 마법 인형',
  9395: '다크 엘프 마법 인형',
  9398: '요정 마법 인형',
  9401: '요정 마법 인형',
  9404: '환 술사 마법 인형',
  9407: '환 술사 마법 인형',
  9411: '나이트 마법 인형',
  9414: '나이트 마법 인형',
  9635: '로드 마법 인형',
  9638: '로드 마법 인형',
  9660: '이상한 장난감 상인',
  9692: '마법 인형 : 에루레구',
  9698: '마법 인형 : 레데구',
  9704: '마법 인형 : 그렉',
  9710: '마법 인형 : 부루레구',
  10002: '시련의 굴',
  10042: '케빠루레',
  10050: '다크 디저트 플라워',
  10071: '샌드웜',
  10150: '라스타바드 큐브',
  10154: '마법 인형 : 바다 사자 (대)',
  10157: '마법 인형 : 바다 사자 (소)',
  10169: '마법 인형 : 고슴도치 (소)',
  10172: '마법 인형 : 고슴도치 (대)',
  10226: '마법 인형 : 펭귄 (대)',
  10229: '마법 인형 : 펭귄 (소)',
  10232: 'Lv52 사무라이',
  10235: 'Lv57 사무라이',
  10238: 'Lv62 사무라이',
  10245: 'Lv52 음양사',
  10248: 'Lv57 음양사',
  10256: '드레이크 마법 인형',
  10259: 'Lv52 다이묘',
  10262: 'Lv57 다이묘',
  10273: 'Lv62 음양사',
  10275: 'Lv62 공주 무사',
  10276: 'Lv62 닌자',
  10277: 'Lv62 다이묘',
  10283: 'Lv52 공주 무사',
  10286: 'Lv57 공주 무사',
  10295: '지그프리드',
  10306: 'Lv52 닌자',
  10309: 'Lv57 닌자',
  10354: '雪壁の アイスマン',
  10483: '이상한 상인',
  10490: '히노 모토 혜택 여장',
  10491: '佐 ノ 길',
  10566: '갓파',
  10573: '드레이크',
  10576: '없는 네',
  10588: '울 솥',
  10594: '도라카',
  10595: '카쟈루',
  10596: '리칸토',
  10598: '쟈카루',
  10599: '카마 이타치',
  10609: '드워프 병사',
  10610: '드워프 마법사',
  10611: '드워프 파이터',
  10612: '드워프 파이크',
  10613: '드워프 도끼',
  10614: '드워프 아처',
  10615: '오크 주술사',
  10616: '오크 병사',
  10617: '오크 궁수',
  10619: '호노스오쿠',
  10620: '오크 창병',
  10621: '네쿠로스',
  10622: 'ボノス オーク パイク',
  10623: '보노 스 오크 도끼',
  10624: '보노 스 오크 궁수',
  10625: '보노 스 오크 주술사',
  10626: '오루쿠스',
  10627: '사악한 셀로브',
  10629: '배신자 엘더',
  10630: '배신자 엘더',
  10631: '디저트 괴물 눈',
  10632: '아루휘아',
  10635: '루퍼스',
  10641: '돌 골렘',
  10642: '만년 슬라임',
  10643: '부식 된 좀비',
  10647: '부식 된 해골 도끼 병',
  10648: '부식 된 해골 창병',
  10649: '부식 된 해골 궁수',
  10651: '부식 된 좀비 제네럴',
  10654: '부식 된 해골 기사',
  10655: '우귀',
  10659: '붉은 악마',
  10661: '푸른 악마',
  10669: '창고지기',
  10680: 'ろくろ首',
  10713: '창고지기',
  10717: '펭귄 (오빠) 마법 인형',
  10720: '똑똑한 펭귄 (오빠) 마법 인형',
  10723: '빛나는 펭귄 (오빠) 마법 인형',
  10726: '눈부신 펭귄 (오빠) 마법 인형',
  10729: '펭귄 (여동생) 마법 인형',
  10732: '똑똑한 펭귄 (여동생) 마법 인형',
  10735: '빛나는 펭귄 (여동생) 마법 인형',
  10738: '눈부신 펭귄 (여동생) 마법 인형',
  10741: '노력하는 펭귄 (오빠) 마법 인형',
  10742: '영리한 펭귄 (오빠) 마법 인형',
  10743: '노력하는 펭귄 (여동생) 마법 인형',
  10744: '영리한 펭귄 (여동생) 마법 인형',
  10750: '종이 우산 귀신',
  10759: '텐구',
  10768: '아수라 상',
  10773: '白面 황금 머리 구미호 · 玉藻',
  10790: '많은 좀비',
  10792: '다크 엘모어 병사',
  10793: '엘모어 마법사',
  10794: '엘모어 제너럴',
  10796: '雪壁の アイスマン',
  10797: '눈 벽 설인',
  10798: '눈 벽 아이스 골렘',
  10799: '눈 벽 아이언 골렘',
  10800: '눈 벽 샤벨 타이거',
  10851: '白面 황금 머리 구미호 · 구미호',
  10859: '白面 황금 머리 구미호 · 살생 석',
  10884: '狂風のシャスキ',
  10891: '빅 풋 마요',
  10899: '에루쟈베',
  10913: '가샤 촉루',
  10968: '성난 울 솥',
  10969: '카마 이타치 맏형',
  10984: '발라카스',
  11092: '리치 마법 인형',
  11102: '호랑이 助',
  11103: '히요시 환',
  11104: '소 로쿠',
  11105: '만키 치',
  11129: '옴 파이터',
  11130: '헤비 오움 전사',
  11131: '다크 엘프 시프',
  11135: '다크 엘프 제너럴',
  11136: '블랙 타이거',
  11137: '울프 비스트 테이머',
  11139: '헬 바운드',
  11140: '헬 크리처',
  11141: '다크 엘프 마법사',
  11142: '땅의 정령 수호자',
  11143: '물의 정령 가디언',
  11144: '바람의 정령 수호자',
  11145: '불 정령 수호자',
  11146: '어둠의 정령 수호자',
  11147: '어둠의 마법사',
  11148: '어둠 숲지기',
  11149: '다크로드',
  11150: '어둠의 복수 자',
  11151: '혈액 사악',
  11152: '블러디 나이트',
  11155: '라스타바드 근위병',
  11156: '여단장 다크 팬더',
  11158: '친위대 장 카이트',
  11159: '장로 수행원',
  11160: '암살 군왕 슬레이브',
  11161: '암살 단장 블레이즈',
  11162: '마수 군왕 바란카',
  11163: '마령 군왕 라이아',
  11164: '명법 군왕 헬 바인',
  11165: '대법관 라미 아스',
  11166: '대법관 바로 드',
  11167: '대법관 바로 메스',
  11168: '대법관 비아 타스',
  11169: '대법관 엔디 아스',
  11170: '대법관 이데아',
  11171: '대법관 케이',
  11172: '대법관 티아 메스',
  11173: '오튜',
  11174: '와이번',
  11175: '튜폰',
  11178: '저주받은 다크 엘프 마법사',
  11197: '악몽',
  11203: '시간의 균열',
  11214: '저주받은 다크 엘프 파이터',
  11215: '저주받은 다크 엘프 기사',
};
